import { render, staticRenderFns } from "./BonusPool.vue?vue&type=template&id=327ed8ac&scoped=true&"
import script from "./BonusPool.vue?vue&type=script&lang=ts&"
export * from "./BonusPool.vue?vue&type=script&lang=ts&"
import style0 from "./BonusPool.vue?vue&type=style&index=0&id=327ed8ac&prod&lang=css&"
import style1 from "./BonusPool.vue?vue&type=style&index=1&id=327ed8ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327ed8ac",
  null
  
)

export default component.exports